import { ReactComponent as DraftIcon } from "../../icons/draft.svg";
import { ReactComponent as DownloadIcon } from "../../icons/download.svg";
import { ReactComponent as CloseIcon } from "../../icons/close.svg";
import { AttachFileMode, AttachFileProps } from "./types/attachFileProps";
import { iconStyle } from "../shared/stylization";
import './attachFileRow.scss';

const AttachFileRow = (props: AttachFileProps) => {
    const handleClick = () => {
        props.onClick(props.info);
    }

    return (<div className="attachFile-row" title={props.mode === AttachFileMode.Download ? "Pobierz załącznik" : "Usuń załącznik"} onClick={handleClick}>
        <DraftIcon />
        <span className="attachFile-name">{props.info.name}</span>
        {props.mode === AttachFileMode.Download
            ? <DownloadIcon style={iconStyle} title="Pobierz załącznik" />
            : <CloseIcon style={iconStyle} title="Usuń załącznik" />}
    </div>
    )
}

export default AttachFileRow;